document.addEventListener("DOMContentLoaded", function() {
  const familyValue = localStorage.getItem('family_value')||"";  
  const lengthString = localStorage.getItem('recommendedProducts_length');
    const length = parseInt(lengthString);

    if (length === 0) {
        setTimeout(function() {
            ordernow_data(familyValue);
        }, 100); // Call the ordernow function after 1 second
    }else{
      
    }
});

function ordernow_data(tagFamily){                    
        var filteredPro = [];
              
              var compare_at_price_data=""
              var actual_price_data =""
                var productTag = "{{ tag }}";
                  console.log(productTag,'productTag>>>>')
                var prodTitle = $('.cart-product-link').data('title');
                  console.log("prodTitle>>>>",prodTitle)
                var prodId = $('.product-cart-item-info').data('id');
                 console.log("prodId>>>>",prodId)
                 const tags = Array.from(document.querySelectorAll('.product-cart-item-info'))
                      .map(info => info.dataset.familytag)
                      .filter((value, index, self) => self.indexOf(value) === index); // Remove duplicates

                  console.log(tags,'tagstagstags>>>>')
                // var prod_family = $('.product').data('family');
                // var prod_type = $('.product').data('type');
                // var prod_color = $('.product').data('metacolor');
                var tagFamily = $('.product-cart-item-info').data('familytag');
 
                var prodVendor = $('.product-cart-item-info').data('prodvendor');
 
                var shopName = "{{ shop.name }}";
                if(shopName.includes('Development')){
                    var STOREFRONT_ACCESS_TOKEN = '58585bbe85b7039defbcef580a5c92cd';
                    var GRAPHQL_URL = 'https://debras-development.myshopify.com/api/2022-10/graphql.json';
                }
                else{
                    var STOREFRONT_ACCESS_TOKEN = '58585bbe85b7039defbcef580a5c92cd';
                    var GRAPHQL_URL = 'https://debrasaustralia.myshopify.com/api/2022-10/graphql.json';
                }


                var productQuery = () => ` {
              products(query:"tag:'${productTag}'", first:250) {
                 edges {
                    node {
                      id
                      title
                      tags
                      handle
                      images(first:20){
                      edges{
                          node{
                            src
                           }
                          }
                          }
                      options {
                        id
                        name
                        values
                      }
                        variants(first: 250) {
                        edges {
                          node {
                            id
                            title
                            sku
                            availableForSale
                            quantityAvailable
                            barcode
                            selectedOptions {
                              name
                              value
                            }
                            requiresShipping
                            weight
                            price {
                              amount
                              currencyCode
                            }
                            image {
                              src
                            }
                            currentlyNotInStock
                          }
                        }
                    }
                    }
                  }
                }
  }`;




    var queryMain = ` {
        products(first:250, query:"tag:'${tagFamily}'")
        {
            edges
            {
                node
                {
                    handle
                    id
                    tags
                    vendor
                    metafields(identifiers:[{namespace: "zimble", key: "color"},
                     {namespace: "zimble", key: "product_type"}])
                    {
                        id 
                        value
                        namespace
                        key
                    }
                    title
                    variants(first: 100) {
                     edges {
                                node {
                                title
                                id
                                availableForSale
                                  compareAtPriceV2 {
                                  amount
                                  currencyCode
                                  }
                                  priceV2 {
                                    amount
                                    currencyCode
                                  }
                                }
                              }
                            }
                    images(first:20){
                      edges{
                          node{
                            src
                           }
                      }
                  }
                }
            }
        }
    }`

        
    var GRAPHQL_BODY_QUERY = () => {
        return {
            'async': true,
            'crossDomain': true,
            'method': 'POST',
            'headers': {
                'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
                'Content-Type': 'application/graphql',
            },
            'body': queryMain
        };
    }

    var FetchData = fetch(GRAPHQL_URL, GRAPHQL_BODY_QUERY())
        .then((res) => res.json())
        .then((products) => {
           console.log(products,'productsproductsproducts')
                let finalArr=products.data.products.edges 
          // console.log(finalArr,'finalArrfinalArr11111111111111')
           const Tags = document.querySelectorAll('.cart-product-link');
          
           

          
        let tagA = Array.from(Tags).map(tag => tag.getAttribute('name')).filter(Boolean);
        // console.log(tagA, 'tagA');

        // Split the single string tagA[0] into an array of tags
        let tagAArray = tagA[0].split(',').map(tag => tag.trim());
         // console.log(tagAArray,'tagAArraytagAArraytagAArraytagAArray')
          
              finalArrr = finalArr.filter(item => {
 
            if (Array.isArray(item.node.tags) && item.node.tags.length > 0) { 
              let ext = tagAArray.filter(tags => item.node.tags.includes(tags.trim()));
               if(ext.length!=tagAArray.length)
               {
                const newitem=item;
                return newitem;
               }
               
            } 
        });
          
      
            // console.log(finalArrr,'finalArrfinalArrfinalArrfinalArrrr') 
            updateDOM(finalArrr);
     
    });

  
function updateDOM(products) {
    if(products.length === 0){
          const recommendationsContainer = document.querySelector('product-recommendations');
          if (recommendationsContainer) {
            // recommendationsContainer.style.display = 'none';
          }
    }else{
      const recommendationsContainer = document.querySelector('product-recommendations');
        if (recommendationsContainer) {
          recommendationsContainer.style.display = 'block';
        }
    }
setTimeout(() => {
  const container = document.getElementById('product-container');
  if (!container) {
    console.error('Product container not found.');
    return;
  }
  console.log("Fetching cart data...");

  // Function to sort variants
  function sortVariants(variants) {
    return variants.slice().sort((a, b) => {
      const titleA = a.node.title;
      const titleB = b.node.title;

      const isNumericA = !isNaN(titleA);
      const isNumericB = !isNaN(titleB);

      if (isNumericA && isNumericB) {
        return parseFloat(titleA) - parseFloat(titleB);
      } else if (isNumericA) {
        return -1;
      } else if (isNumericB) {
        return 1;
      } else {
        return titleA.localeCompare(titleB);
      }
    });
  }

  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cartData => {
      console.log("Cart data fetched:", cartData);

      const cartProductTitles = cartData.items.map(item => normalizeTitle(item.product_title));
      let htmlContent = '';

      products.forEach(productt => {
    const product = productt.node;
    const product_title = product?.title;
    var brand = product_title.split(':')[0];
    var prdTittle = product_title.split(':')[1];

    if (!product || !product.variants || !product.variants.edges) {
        console.error('Product or product variants are undefined:', product);
        return;
    }

    const variantID = product.id.split('/').pop();
    const imageWith99 = product.images.edges.find(edge => edge.node.src.includes('_99'))?.node.src;
    const firstVariant = product.variants.edges[0]?.node;
    let firstVariantPrice = firstVariant.priceV2.amount;

    // Check if the price has no decimals
    if (Number(firstVariantPrice) % 1 === 0) {
        // If no decimal, force 2 decimals
        firstVariantPrice = parseFloat(firstVariantPrice).toFixed(2);
    }
        
        
    if (!imageWith99 || !firstVariant) {
        console.log(`Skipping product ${product.title} due to missing data.`);
        return;
    }

    const sortedVariants = sortVariants(product.variants.edges);
    console.log("sortedVariants", sortedVariants);
    const hasAvailableVariant = sortedVariants.some(variant => variant.node.availableForSale);
    console.log("hasAvailableVariant", hasAvailableVariant);
    
    const recommendationsContainer = document.querySelector('product-recommendations');

      if (hasAvailableVariant && !cartProductTitles.includes(normalizeTitle(product.title))) {
        console.log(`Product ${product.title} not in cart.`);
        setTimeout(() => {
            document.querySelectorAll('select[name="option-0"]').forEach(selectElement => {
                selectElement.addEventListener('change', function () {
                    const parentDiv = selectElement.closest('.product_99_img');
                    const submitButton = parentDiv.querySelector('input[type="submit"]');
                    const selectedValue = selectElement.value;
                    const firstOption = selectElement.querySelector('option:first-child').value;
                    if (selectedValue !== firstOption && selectedValue !== "") {
                        submitButton.classList.add('active');
                        let errorMessage = parentDiv.previousElementSibling?.classList.contains('error-message')
                            ? parentDiv.previousElementSibling
                            : parentDiv.querySelector('.error-message');
                        if (errorMessage) {
                            errorMessage.remove();
                        }
                    } else {
                        submitButton.classList.remove('active');
                    }
                });
            });
      
            document.querySelectorAll('.cart-form').forEach(form => {
                form.addEventListener('submit', function (e) {
                    e.preventDefault();
      
                    const parentDiv = form.closest('.product_99_img');
                    const selectElement = parentDiv.querySelector('select[name="option-0"]');
                    const selectedValue = selectElement.value;
                    const firstOption = selectElement.querySelector('option:first-child').value;
                    const submitButton = form.querySelector('input[type="submit"]');
      
                    if (selectedValue === firstOption || selectedValue === "") {
                        let errorMessage = parentDiv.previousElementSibling?.classList.contains('error-message')
                            ? parentDiv.previousElementSibling
                            : parentDiv.querySelector('.error-message');
      
                        if (!errorMessage) {
                            errorMessage = document.createElement('div');
                            errorMessage.classList.add('error-message');
                            errorMessage.textContent = 'Please select your size';
                            parentDiv.parentNode.insertBefore(errorMessage, parentDiv);
                        }
                    } else {
                        const errorMessage = parentDiv.previousElementSibling?.classList.contains('error-message')
                            ? parentDiv.previousElementSibling
                            : parentDiv.querySelector('.error-message');
      
                        if (errorMessage) {
                            errorMessage.remove();
                        }
                        form.submit();
                    }
                });
            });
      
        }, 1000);
      
        setTimeout(() => {
            const seenTitles = new Map();
            document.querySelectorAll('#Cart-Drawer product-card').forEach(card => {
                const title = card.querySelector('.cart-product-link')?.textContent.trim() || '';
                if (seenTitles.has(title)) {
                    card.style.display = 'none';
                } else {
                    card.style.display = 'flex';
                    seenTitles.set(title, true);
                }
            });
        }, 1000);
      
        if (recommendationsContainer) {
            recommendationsContainer.style.display = 'block';
        }
      
        htmlContent += `
            <div class="carousel__slide recomandation_for_you" id="recomandation_for_you">
              <product-card class="product-cart-item" style="margin-bottom:0px;">
                <div class="product-cart-item-image">
                  <img class="lazyautosizes ls-is-cached lazyloaded" width="1500" height="2040" data-sizes="auto" src="${imageWith99}" alt="${product.title}" sizes="80px">
                </div>
                <div class="product-cart-item-info eee">
                   <span class="brand_name_title">${brand}</span>
                  <a href="/products/${product.handle}" title="${product.title}" class="cart-product-link">${prdTittle}</a>
                  <span class="price">
                    <ins><span class="amount">$${firstVariantPrice}</span></ins>
                  </span>
                  <div class="cstm_add_to_cart_b2b product_99_img">
                    <select onchange="myfun(this);" id="size" name="option-0" class="custom_select_size sizeSelect hide_product_true">
                      <option value="">Choose Your Size</option>
                      ${sortedVariants
                        .filter(variant => variant.node.availableForSale) // Filter available variants
                        .map(variant => {
                          const [size] = variant.node.title.split(' / '); // Get the size before the slash
                          return `<option value="${variant.node.id}">${size}</option>`;
                        })
                        .join('')}
                    </select>
                    <form class="cart-form" method="post" action="/cart/add">
                      <input name="id" value="${variantID}" type="hidden" />
                      <input type="submit" name="add" value="ADD To CART" class="product_99_img_btn"/>
                    </form>
                  </div>
                </div>
              </product-card>
            </div>
        `;
      } else {
        console.log(`Product ${product.title} already in cart or has no available variants.`);
      }
      });
      // if (htmlContent) {
        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = htmlContent;
        while (tempContainer.firstChild) container.appendChild(tempContainer.firstChild);
        // console.log('Appended new HTML content to product container.',htmlContent);

        const loader = document.getElementById('loadercart');
        if (loader) loader.style.display = 'none';

        setTimeout(() => {
          const productLinkItems = document.querySelectorAll('.product-cart-item--container .cart-product-link');
          const productLinks1 = container.querySelectorAll('.cart-product-link');
          productLinkItems.forEach(link => {
            const title = link.title;
            productLinks1.forEach(link1 => {
              if (link1.title === title) {
                const carouselSlide = link1.closest('.carousel__slide');
                if (carouselSlide) carouselSlide.style.display = 'none';
              }
            });
          });
        }, 1000);
      const sortSelectOptionsAlphanumeric = () => {
      const selects = document.querySelectorAll(".sizeSelect");
      
      selects.forEach(select => {
        // Get all option elements, excluding the first one (placeholder)
        const options = Array.from(select.options).slice(1);
      
        // Sort by visible text content using localeCompare with numeric option
        options.sort((a, b) => {
          const textA = a.textContent.trim();
          const textB = b.textContent.trim();
          
          return textA.localeCompare(textB, undefined, { 
            numeric: true,        // Handles numbers properly (e.g., 10 comes after 2)
            sensitivity: "base"   // Case-insensitive comparison
          });
        });
      
        // Clear existing options (keep the placeholder)
        while (select.options.length > 1) {
          select.remove(1);
        }
      
        // Add sorted options back
        options.forEach(option => {
          select.add(option);
        });
      });
      };
      sortSelectOptionsAlphanumeric();
      // } else {
      //   console.log('No new HTML content to display.');
      // }
    })
    .catch(error => console.error('Error fetching cart data:', error));
}, 1000);



}


   }

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

// /**
//  *  @class
//  *  @function Quantity
//  */
// if (!customElements.get('quantity-selector')) {
//   class QuantityInput extends HTMLElement {
//     constructor() {
//       super();
//       this.input = this.querySelector('.qty');
//       this.step = this.input.getAttribute('step');
//       this.changeEvent = new Event('change', {
//         bubbles: true
//       });
      
//       // Create buttons
//       this.subtract = this.querySelector('.minus');
//       this.add = this.querySelector('.plus');

//       // Add functionality to buttons
//       this.subtract.addEventListener('click', () => {
//         let quantity = Number(this.input.value);

//         // New condition: If quantity is 1, prevent further decrement
//         if (quantity === 1) {
//           return;
//         }

//         const inventoryPolicy = this.input.getAttribute('inventory-policy');
//         let availableQuantity = Number(localStorage.getItem('availableQuantity'));
//         let continue_selling = localStorage.getItem('continue_selling');

//         if (quantity <= availableQuantity && continue_selling !== 'continue') {
//           const availableStock = document.querySelector(".available_stock");
//           const deliveryTime = document.querySelector(".deliveryTime");
//           const yourName = document.getElementById("your-name");

//           if (availableStock) {
//             availableStock.style.display = "none";
//             availableStock.innerHTML = ``;
//           }
//           if (deliveryTime) deliveryTime.style.display = "none";
//           if (yourName) yourName.value = '';
//         } else if (quantity - 1 == availableQuantity && continue_selling == 'continue') {
//           const deliveryTime = document.querySelector(".deliveryTime");
//           const yourName = document.getElementById("your-name");

//           if (deliveryTime) deliveryTime.style.display = "none";
//           if (yourName) yourName.value = '';
//         }
//         this.change_quantity(-1 * this.step);
//       });

//       this.add.addEventListener('click', () => {
//         let quantity = Number(this.input.value);
//         const inventoryPolicy = this.input.getAttribute('inventory-policy');
//         let availableQuantity = Number(localStorage.getItem('availableQuantity'));
//         let continue_selling = localStorage.getItem('continue_selling');

//         if (quantity == availableQuantity && continue_selling !== 'continue') {
//           const availableStock = document.querySelector(".available_stock");
//           const deliveryTime = document.querySelector(".deliveryTime");
//           const yourName = document.getElementById("your-name");

//           if (availableStock) {
//             availableStock.style.display = "flex";
//             availableStock.innerHTML = `There is only ${availableQuantity} item available`;
//           }
//           if (deliveryTime) deliveryTime.style.display = "none";
//           if (yourName) yourName.value = '';
//           return;
//         } else if (quantity >= availableQuantity && continue_selling == 'continue' && quantity <= availableQuantity && continue_selling == 'continue') {
//           const deliveryTime = document.querySelector(".deliveryTime");
//           const yourName = document.getElementById("your-name");

//           if (deliveryTime) deliveryTime.style.display = "flex";
//           if (yourName) yourName.value = localStorage.getItem('expected_delivery_time');
//         }
//         this.change_quantity(1 * this.step);
//       });
//     }

//     connectedCallback() {
//       this.classList.add('buttons_added');
//       this.validateQtyRules();
//     }

//     change_quantity(change) {
//       let quantity = Number(this.input.value);

//       if (isNaN(quantity)) quantity = 1;

//       const minQuantity = Number(this.input.getAttribute('min')) || 1;
//       if (quantity < minQuantity) {
//         return;
//       }

//       const maxQuantity = Number(this.input.getAttribute('max'));
//       quantity += change;
//       quantity = Math.max(quantity, 1);

//       this.input.value = quantity;
//       this.input.dispatchEvent(this.changeEvent);
//       this.validateQtyRules();
//     }

//     validateQtyRules() {
//       const value = parseInt(this.input.value);
//       if (this.input.min) {
//         const min = parseInt(this.input.min);
//         // this.subtract.classList.toggle('disabled', value <= min);
//       }
//       if (this.input.max) {
//         const max = parseInt(this.input.max);
//         // if (value >= max) {
//         //   alert(max, value);
//         //   this.add.classList.toggle('disabled');
//         // }
//       }
//     }
//   }

//   customElements.define('quantity-selector', QuantityInput);
// }

// ================================


/**
 *  @class
 *  @function Quantity
 */
// if (!customElements.get('quantity-selector')) {
//   class QuantityInput extends HTMLElement {
//     constructor() {
//       super();
//       this.input = this.querySelector('.qty');
//       this.step = this.input.getAttribute('step');
//       this.changeEvent = new Event('change', {
//         bubbles: true
//       });
//       // Create buttons
//       this.subtract = this.querySelector('.minus');
//       this.add = this.querySelector('.plus');

//       // Add functionality to buttons
//       this.subtract.addEventListener('click', () => {
//         let quantity = Number(this.input.value);
//         const inventoryPolicy = this.input.getAttribute('inventory-policy');
//         let availableQuantity = Number(localStorage.getItem('availableQuantity'));
//         let continue_selling = localStorage.getItem('continue_selling');
//         if (quantity <= availableQuantity && continue_selling !== 'continue') {
//           document.querySelector(".available_stock").style.display = "none";
//           document.querySelector(".available_stock").innerHTML = ``;
//           document.querySelector(".deliveryTime").style.display = "none";
//           document.getElementById("your-name").value = '';
//         } else if (quantity - 1 == availableQuantity && continue_selling == 'continue') {
//           document.querySelector(".deliveryTime").style.display = "none";
//           document.getElementById("your-name").value = '';
//         }
//         this.change_quantity(-1 * this.step); // Always decrease by step                                          
//       });

//       this.add.addEventListener('click', () => {
//         let quantity = Number(this.input.value);
//         const inventoryPolicy = this.input.getAttribute('inventory-policy');
//         let availableQuantity = Number(localStorage.getItem('availableQuantity'));
//         let continue_selling = localStorage.getItem('continue_selling');
//         if (quantity == availableQuantity && continue_selling !== 'continue') {
//           document.querySelector(".available_stock").style.display = "flex";
//           document.querySelector(".available_stock").innerHTML = `There is only ${availableQuantity} item available`;
//           document.querySelector(".deliveryTime").style.display = "none";
//           document.getElementById("your-name").value = '';
//           return;
//         } else if (quantity >= availableQuantity && continue_selling == 'continue' && quantity <= availableQuantity) {
//           document.querySelector(".deliveryTime").style.display = "flex";
//           document.getElementById("your-name").value = localStorage.getItem('expected_delivery_time');
//         }
//         this.change_quantity(1 * this.step); // Always increase by step
//       });
//     }

//     connectedCallback() {
//       this.classList.add('buttons_added');
//       this.validateQtyRules();
//     }

//     change_quantity(change) {
//       // Get current value and convert it to a number
//       let quantity = Number(this.input.value);

//       // Ensure quantity is a valid number; default to 1 if invalid
//       if (isNaN(quantity)) quantity = 1;

//       // Simply change the quantity by the specified step
//       quantity += change;

//       // Update input value
//       this.input.value = quantity;

//       // Dispatch change event
//       this.input.dispatchEvent(this.changeEvent);

//       // Validate quantity rules (optional)
//       this.validateQtyRules();
//     }

//     validateQtyRules() {
//       const value = parseInt(this.input.value);
//       if (this.input.min) {
//         const min = parseInt(this.input.min);
//         // Optional logic for visual feedback if needed (e.g., disabling buttons)
//       }
//       if (this.input.max) {
//         const max = parseInt(this.input.max);
//         // Optional logic for visual feedback if needed (e.g., disabling buttons)
//       }
//     }
//   }

//   customElements.define('quantity-selector', QuantityInput);
// }



// ================================
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', { bubbles: true });

      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', (event) => this.change_quantity(event, -1 * this.step));
      this.add.addEventListener('click', (event) => this.change_quantity(event, 1 * this.step));
    }

    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }

    change_quantity(event, change) {
    const overlay = document.querySelector("#overlay");
    if (overlay) {
    overlay.style.display = "block";
    } else {
    console.error("Overlay element not found.");
    }
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }

      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      // Dispatch the change event
      this.input.dispatchEvent(this.changeEvent);

      // Call validateQtyRules to handle button disable state
      this.validateQtyRules();

      // Get the button that was clicked (plus or minus)
      const button = event.target.closest('button');

      // Extract attributes from the button
      const totalAvailable = button.getAttribute('total');
      const variantId = button.getAttribute('variant_id');
      const metafieldData = button.getAttribute('metafield_data');
      const currentValue = this.input.value;
      let currentValue1 = parseInt(currentValue) || 1;

      // Show the alert with the values
      // alert(`Current Value: ${currentValue}\nTotal Available: ${totalAvailable}\nVariant ID: ${variantId}\nMetafield Data: ${metafieldData}`);

      let newqty = parseInt(totalAvailable);

      console.log('Current Value (Plus):', currentValue);
      console.log('Total Available (Plus):', newqty,totalAvailable);
      console.log('Metafield Data (Plus):', metafieldData);  // Added to check metafieldData

      // Check if current value is less than available stock
      if (currentValue > newqty) {
        // alert("plus", metafieldData);
        let properties = {
          "🚚": metafieldData,
        };
        updateCartItem(variantId, properties, currentValue1);
      } else {
        // Check if the current value is greater than 1 and available stock allows reducing
        if (currentValue <= newqty) {
         //  alert("Updating cart with minus button");
          const properties = {};
          updateCartItem(variantId, properties, currentValue1);
        } else {
          console.warn('Cannot decrease quantity below 1 or exceed available stock');
        }
      }
    }

    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        // this.add.classList.toggle('disabled', value >= max);
      }
    }
  }

  // Define the custom element
  customElements.define('quantity-selector', QuantityInput);
  function updateCartItem(variantId, properties, quantity) {
    // Show the alert with both variantId and properties
   //alert(`Variant ID: ${variantId}\nProperties: ${JSON.stringify(properties)}`);
    
    const data = {
      id: variantId,
      quantity: quantity,
      properties: properties
    };

    $.ajax({
      url: '/cart/change.js',
      type: 'POST',
      data: JSON.stringify(data),
      contentType: 'application/json',
      dataType: 'json',
      success: function(response) {
        console.log('Cart updated successfully:', response);
       
      function refreshSection() {

        if (window.location.pathname === '/cart') {
          let sections = 'main-cart';
      
          fetch(`${window.location.pathname}/?sections=${sections}`)
            .then((response) => {
              return response.text();
            })
            .then((state) => {
              const parsedState = JSON.parse(state);
            setTimeout(()=>{
               document.querySelector("#overlay").style.display="none";
               setTimeout(()=>{location.reload();},200);
             },2000);
              if (parsedState.errors) {
                this.displayErrors(line, parsedState.errors);
                this.container.classList.remove('cart-disabled');
                return;
              }
      
              this.renderContents(parsedState, false, true);
      
              this.container.classList.remove('cart-disabled');
            });
        } else {}
        
      }
      refreshSection();
      },
      error: function(xhr, status, error) {
        console.error('Error updating cart item:', error);
        console.log(xhr.responseText);
      }
    });
  }
}


/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.secondary = this.querySelector('.product-secondary-image');
      this.image = this.secondary || this.querySelector('.product-primary-image');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.size_options = this.querySelector('.product-card-sizes');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
      if (this.secondary) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(this.secondary);
        });
      }
      if (this.size_options) {
        this.enableSizeOptions();
      }

    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';
      this.color_index = this.swatches.dataset.index;

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener('mouseover', () => {

          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }
          if (this.size_options) {
            this.current_options[this.color_index] = swatch.querySelector('span').innerText;
            this.updateMasterId();
          }
          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll('.product-card-sizes--size'),
        featured_image = this.querySelector('.product-featured-image'),
        has_hover = featured_image.classList.contains('thb-hover'),
        size_parent = this.size_options.parentElement;

      this.size_index = this.size_options.dataset.index;

      this.current_options = this.size_options.dataset.options.split(',');

      this.updateMasterId();

      size_parent.addEventListener('mouseenter', () => {
        if (has_hover) {
          featured_image.classList.remove('thb-hover');
        }
      }, {
        passive: true
      });
      size_parent.addEventListener('mouseleave', () => {
        if (has_hover) {
          featured_image.classList.add('thb-hover');
        }
      }, {
        passive: true
      });
      size_list.forEach((size) => {
        size.addEventListener('click', (evt) => {
          evt.preventDefault();

          if (size.classList.contains('is-disabled')) {
            return;
          }
          this.current_options[this.size_index] = size.querySelector('span').innerText;
          this.updateMasterId();

          size.classList.add('loading');
          size.setAttribute('aria-disabled', true);
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };
          let formData = new FormData();

          formData.append('id', this.currentVariant.id);
          formData.append('quantity', 1);
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);

          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                return;
              }
              this.renderContents(response);

              dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              size.classList.remove('loading');
              size.removeAttribute('aria-disabled');
            });
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.current_options[index] === option;
        }).includes(false);
      });
      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();

      if (variant_data) {

        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });

          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

          const fieldset_options = Object.values(available_options)[this.size_index];
          if (fieldset_options) {
            if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
              this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        } else {
          if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
            this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
              input.classList.add('is-disabled');
            });
          }
        }

      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.getAttribute('disabled') != undefined) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}



/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {

    constructor() {
      super();
      let cc = document.querySelector('.click-capture');
      // Add functionality to buttons
      this.panel = this.closest('.side-panel');
      this.addEventListener('click', (e) => this.close_panel(e));
      this.addEventListener('keydown', (e) => this.close_panel(e));
      cc.addEventListener('click', (e) => this.close_panel(e));
      document.addEventListener('panel:close', (e) => {
        let panel = document.querySelectorAll('.side-panel.active, .open-search .search-drawer');
      
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      });
    }

    close_panel(e, side_panel) {
      let panel = this.panel;
      if (e.code && e.code.toUpperCase() !== 'ENTER') {
        return;
      }
      if (side_panel) {
        panel = side_panel;
      }
      if (!panel) {
        panel = document.querySelector('.side-panel.active');
      }
      if (panel) {
        panel.classList.remove('active');
      }
      if (document.body.classList.contains('open-cc--product')) {
        document.body.classList.remove('open-cc--product');
        setTimeout(() => {
          document.querySelector('#Product-Drawer-Content').innerHTML = '';
        }, 260);
      } else if (panel?.classList.contains('cart-drawer') && document.querySelector('.view-products-panel.active')) {
        return;
      } else {
        if (document.body.classList.contains('open-search')) {
          document.body.classList.remove('open-search');
        }
        document.body.classList.remove('open-cc');
      }

      if (document.body.classList.contains('overflow-hidden')) {
        document.body.classList.remove('overflow-hidden');
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    this.button = document.getElementById('cart-drawer-toggle');

    // Add functionality to buttons
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.add('open-cc');
      document.body.classList.add('open-cart');
      this.classList.add('active');
      this.focus();
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      });
      dispatchCustomEvent('cart-drawer:open');
    });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    document.addEventListener('cart:refresh', (event) => {
      this.refresh();
    });

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.notesToggle();
    this.removeProductEvent();
    this.updateFreeShipping();
    // Terms checkbox
    this.termsCheckbox();
  }
  onChange(event) {
    if (event.target.classList.contains('qty')) {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    }
  }
  removeProductEvent() {
    
    let removes = this.querySelectorAll('.remove');
        

    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
       
        this.updateQuantity(event.target.dataset.index, '0');

        event.preventDefault();
         
           
      });
    });
  }
  getSectionsToRender() {
    return [{
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer-inner'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  termsCheckbox() {
    let terms_checkbox = this.querySelector('#CartDrawerTerms'),
      checkout_button = this.querySelector('.button.checkout');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  notesToggle() {
    let notes_toggle = this.querySelector('#order-note-toggle');

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener('click', (event) => {
      notes_toggle.nextElementSibling.classList.add('active');
    });
    notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
      el.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.remove('active');
        this.saveNotes();
      });
    });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('mini-cart__notes').value
      })
    });
  }
  updateFreeShipping() {
    const free_shipping = this.querySelector('.free-shipping');

    if (free_shipping) {
      let amount_text = free_shipping.querySelector('.free-shipping--text span');
      let total = parseInt(free_shipping.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(free_shipping.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;

      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          let remaining = minimum - total,
            format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amount_text.innerHTML = formatMoney(remaining, format);
        }
      }

      free_shipping.style.setProperty('--percentage', percentage);
    }
  }
  updateQuantity(line, quantity) {
    this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });

    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      ...{
        body
      }
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));

        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        this.updateFreeShipping();
        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });

        if (this.querySelector(`#CartDrawerItem-${line}`)) {
          this.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
        }
      });
  }
  refresh() {
    let sections = 'cart-drawer,cart-bubble';
    fetch(`${window.location.pathname}?sections=${sections}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
        }));

        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        this.updateFreeShipping();
      });
  }
}
customElements.define('cart-drawer', CartDrawer);

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelector('[id^="ModalClose-"]');

    if (this.closeButton) {
      this.closeButton.addEventListener(
        'click',
        this.hide.bind(this)
      );
      this.closeButton.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ENTER') {
          this.hide();
        }
      });
    }

    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.hide();
      }
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    if (this.dataset.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');

    setTimeout(() => {
      this.closeButton.focus();
    }, 100);
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    // // this.removeAttribute('open');
    //   const modals = document.querySelectorAll('.quick-add-modal');
    //     modals.forEach(modal => {
    //         modal.removeAttribute('open');
    //     });
    this.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    this.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    this.querySelectorAll('video').forEach((video) => video.pause());
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture--product');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.cc.addEventListener('click', this.setupCCEventListener.bind(this));

    }
    setupCCEventListener(e) {
      this.body.classList.remove('open-cc--product');
      this.drawer.classList.remove('active');

      setTimeout(() => {
        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = '';
      }, 260);

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      if (this.disabled) {
        return;
      }
      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add('open-cc--product');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds && typeof (recentIds) !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

/**
 *  Animations
 */
ScrollTrigger.batch('.animations-true .products .gallery--item figure, .animations-true .product-card .product-featured-image-link', {
  start: "top 90%",
  onEnter: (elements, triggers) => {
    gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
  }
});
ScrollTrigger.batch('.animations-true .multicolumn--column-inner', {
  start: "top 90%",
  onEnter: (elements, triggers) => {
    gsap.to(elements, { y: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
  }
});
ScrollTrigger.batch('.animations-true .blog-post .featured-image--link', {
  start: "top 90%",
  onEnter: (elements, triggers) => {
    gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
  }
});

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});

/* ========================== sdev code for size filter jul-26-2024 time:2:37pm ============================================*/

/* ========================== sdev code for size filter jul-26-2024 time:2:37pm ============================================*/
/* ==========================  model-dailog close button ================================================*/
        document.addEventListener('DOMContentLoaded', () => {
         const closeButtons = document.querySelectorAll('.product_popup-modal_closeSize');
            closeButtons.forEach(button => {
            button.addEventListener('click', () => {
            const modals = document.querySelectorAll('modal-dialog.product_popup-modal_Size');
              modals.forEach(modal => {
              modal.removeAttribute('open');
              });
            });
            });
        });
        // document.addEventListener('DOMContentLoaded', () => {
        //     const closeButton = document.querySelector('.facets-popup-modal');
        //     closeButton.addEventListener('click', () => {
        //         const modals = document.querySelectorAll('modal-dialog');
        //         modals.forEach(modal => {
        //             modal.removeAttribute('open');
        //         });
        //     });
        // });
          document.addEventListener('DOMContentLoaded', () => {
              // Select all elements with the class 'side-panel-close'
              const closeButtons = document.querySelectorAll('.side-panel-close');
          
              // Add click event listeners to each close button
              closeButtons.forEach(button => {
                  button.addEventListener('click', () => {
                      // Select all <modal-dialog> elements
                      const modals = document.querySelectorAll('modal-dialog');
                      
                      // Iterate over the NodeList and remove the 'open' attribute from each modal
                      modals.forEach(modal => {
                          modal.removeAttribute('open');
                      });
                  });
              });
          });
          document.addEventListener('DOMContentLoaded', () => {
              // Select all elements with the class 'side-panel-close'
              const closeButtons = document.querySelectorAll('.thb-localization-forms-modal__toggle');
          
              // Add click event listeners to each close button
              closeButtons.forEach(button => {
                  button.addEventListener('click', () => {
                      // Select all <modal-dialog> elements
                      const modals = document.querySelectorAll('modal-dialog');
                      
                      // Iterate over the NodeList and remove the 'open' attribute from each modal
                      modals.forEach(modal => {
                          modal.removeAttribute('open');
                      });
                  });
              });
          });
/* ==========================  model-dailog close button ================================================*/

/* ========================== product variant selected via filter  ==================================*/
    function getVariantIdFromURL() {
            const url = window.location.href;
            const urlParams = new URLSearchParams(new URL(url).search);
            return urlParams.get('variant');
        }

        function setSelectedOption(variantId) {
            const selectElement = document.getElementById('Option-template--19151694430464__main-0');
            const options = selectElement.options;

            for (let i = 0; i < options.length; i++) {
                if (options[i].getAttribute('variant_id') === variantId) {
                    selectElement.selectedIndex = i;
                    break;
                }
            }
        }
        const variantId = getVariantIdFromURL();
        if (variantId) {
            setSelectedOption(variantId);
        }

        document.addEventListener("DOMContentLoaded", function() {
            var fromDateStart = document.querySelector('.fromDateStart');
            var getInParagraph = document.getElementById('getIn');
            
            if (!fromDateStart.textContent.trim()) {
                getInParagraph.style.display = 'none';
            }
        });
/* ========================== product variant selected via filter  ==================================*/



document.addEventListener('DOMContentLoaded', () => {
  const parentElement = document.querySelector('body');
  
  if (parentElement) {
    parentElement.addEventListener('click', async (event) => {
      const button = event.target.closest('.remove');
      
      if (button) {
        event.preventDefault();
        alert("sadd");

        // Call the function to clear the cart based on the condition
        await clearCartBasedOnCondition();
      }
    });
  }
});

async function clearCartBasedOnCondition() {
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await response.json();

    // Get all product IDs of cart items to compare against each item’s _prd_id_main
    const prd_id_data = cart.items.map(item => item.product_id).join(',');

    // Sequentially check each item and remove it if it meets the condition
    for (const item of cart.items) {
      await removeItemBasedOnDynamicProductId(item, prd_id_data);
    }

    // Update the cart drawer after all applicable items are removed
    console.log('Applicable items removed.');
    updateCartDrawer();

  } catch (error) {
    console.error('Error fetching cart:', error);
  }
}

async function removeItemBasedOnDynamicProductId(item, prd_id_data) {
  // Check if item has custom property _prd_id_main
  if (item.properties && item.properties._prd_id_main) {
    const productIds = item.properties._prd_id_main.split(',');
    const prd_id = parseInt(productIds[0], 10);
    const remove_variant_id = productIds[1];

    // Condition: remove item if prd_id is not in prd_id_data
    if (!prd_id_data.split(',').includes(prd_id.toString())) {
      try {
        const removeResponse = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: remove_variant_id,
            quantity: 0
          })
        });
        
        const updatedCart = await removeResponse.json();
        console.log(`Item with ID ${remove_variant_id} removed. Updated cart:`, updatedCart);

      } catch (error) {
        console.error(`Error removing item with ID ${remove_variant_id}:`, error);
      }
    }
  }
}


// function adjustBlogHeight() {
//             const titleElements = document.querySelectorAll('.blog-post h5');
            
//             let maxHeight = 0;
//             titleElements.forEach(title => {
//                 const height = title.offsetHeight;
//                 if (height > maxHeight) {
//                     maxHeight = height;
//                 }
//             });
//             titleElements.forEach(title => {
//                 title.style.height = `${maxHeight}px`;
//                 title.style.boxSizing = 'border-box';
//             });
//       if (window.location.href.indexOf('?contact_posted=true#ContactForm') !== -1 || 
//               window.location.href.indexOf('?contact_posted=true#contact_form') !== -1) {
//               // Remove the 'hide' class to display the message
//               document.querySelector('.form__message').classList.remove('hide');
//           }
//         }
//  window.addEventListener('load', adjustBlogHeight());


document.addEventListener("DOMContentLoaded", function () {
// Check if the URL contains "/collections/"
if (window.location.pathname.includes("/collections/")) {
    const url = new URL(window.location.href);
    if (!url.searchParams.has("filter.v.availability")) {
        // If the parameter doesn't exist, add it with value "1"
        url.searchParams.set("filter.v.availability", "1");

        // Trigger the URL change without reloading the page
        window.history.pushState({}, "", url.toString());

        // Log the updated URL
        console.log("Updated URL:", window.location.href);
    } else {
        console.log("The 'filter.v.availability' parameter already exists:", url.searchParams.get("filter.v.availability"));
    }
} else {
    // console.log("The URL does not contain /collections/");
}

// Listen for URL changes and log them (if necessary)
window.onpopstate = function() {
    // console.log("URL changed:", window.location.href);
};

window.onhashchange = function() {
    // console.log("Hash changed:", window.location.hash);
};

});

document.body.addEventListener('click', function(event) {
    // Check if the clicked element is the button (using class or other identifier)
    if (event.target.closest('.plus_quantity_btn')) {
      var button = event.target.closest('.plus_quantity_btn');
      
      // Disable the button immediately after click
      button.disabled = true;

      // Set a timeout to enable the button after 1 minute (60000 ms)
      setTimeout(function() {
        button.disabled = false;
      },1000);
    }
  });